export const eu = {
    LEFT: 'Ezker: Mugitu aurreko egunean.',
    RIGHT: 'Eskuin: Mugitu hurrengo egunean.',
    DOWN: 'Behera: Mugitu hurrengo errenkadan.',
    UP: 'Sortu: Mugitu aurreko errenkadan.',
    PGUP: 'PgUp: Mugitu aurreko hilaren aldean.',
    PGDOWN: 'PgDown: Mugitu hurrengo hilabetean.',
    HOME: 'Hasiera: Mugitu aurreko urtean.',
    END: 'End: Mugitu hurrengo urtean.',
    ESC: 'Esc/Gaur/Itxi: itxi egutegia.',
    TITLE: 'Teklatua Argibideak'
};
